import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const StubContainerBottom = styled(Box)
    .withConfig({ displayName: 'SearchAppPanelStubBottom' })
    .attrs({
        position: 'fixed',
        left: 0,
        boxSizing: 'border-box',
        minWidth: '100vw',
        maxWidth: '100vw',
        height: 700,
        pointerEvents: 'none',
        bottom: '-700px',
        zIndex: 99999999,
        backgroundColor: 'var(--background-secondary)',
    })``;

export const StubContainerTop = styled(Box)
    .withConfig({ displayName: 'SearchAppPanelStubTop' })
    .attrs({
        position: 'fixed',
        left: 0,
        boxSizing: 'border-box',
        minWidth: '100vw',
        maxWidth: '100vw',
        height: 700,
        pointerEvents: 'none',
        top: '-700px',
        zIndex: 99999999,
        backgroundColor: 'var(--background-secondary)',
    })``;
